<script>
export default {
  name: 'Jsx',
  props: {
    rf: {
      type: Function
    }
  },
  render() {
    return this.rf(this.$parent.$createElement)
  }
}
</script>
